import { cx } from "class-variance-authority";
const RequriedIcon = <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.552 0.00399935H4.532L4.434 2.734L6.926 1.782L7.234 2.706L4.658 3.476L6.394 5.534L5.638 6.136L4.042 3.924L2.446 6.136L1.69 5.534L3.426 3.476L0.85 2.706L1.158 1.782L3.664 2.734L3.552 0.00399935Z" fill="#B10E1C" />
  </svg>;
export default function RequiredLabel({
  children,
  position = "right",
  className
}: {
  children: React.ReactNode;
  position?: "left" | "right";
  className?: string;
}) {
  return <div className={cx("flex h-[22px] gap-1 leading-[22px]", className)} data-sentry-component="RequiredLabel" data-sentry-source-file="required-label.tsx">
      {position === "left" && <div className="pt-1">{RequriedIcon}</div>}
      {children}
      {position === "right" && <div className="pt-1">{RequriedIcon}</div>}
    </div>;
}